'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _collection = require('lodash/collection');

/**
 *  Normalizes an array of objects or possibly an object containing arrays to an object
 *  @param {Object} val - The value to be normalized
 *  @returns {Object} The normalized object
 */
function normalizeArray(val) {
  if (Array.isArray(val)) {
    if (val.length > 1 && Object.prototype.hasOwnProperty.call(val[0], 'name')) {
      return (0, _collection.keyBy)(val, function (field) {
        return field.name;
      });
    }
  } else if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    for (var key in val) {
      if (Object.prototype.hasOwnProperty.call(val, key)) {
        val[key] = normalizeArray(val[key]);
      }
    }
  }
  return val; // if unrecognized just return
}

/**
 * Transforms the form configuration from the API into a more usable format.
 * @param {Object} formConfig - The form configuration from the API.
 * @returns {Object} The transformed form configuration.
 */

exports.default = function (formConfig) {
  if (Array.isArray(formConfig)) {
    return formConfig; // already configured
  }
  var steps = formConfig.form.steps;

  return steps.map(function (step) {
    step.fields = normalizeArray(step.fields);
    return step;
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/common/formConfiguration.js
// module id = 40
// module chunks = 0